function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#e83147",
  d: "m 0.5,22.333666 h 5 v 5 h -5 z M 0.5,0.667 h 5 v 16.666666 h -5 z"
});
const SvgIcExclamation = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "6px",
  height: "28px",
  viewBox: "0 0 6 28",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcExclamation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-exclamation.6b1f0775.svg";
export { ForwardRef as ReactComponent };